module.exports = __webpack_public_path__ + "media/v2/icon_page-0f249cc7.svg";